import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface PropsInterface {
    descriptionTooltipTranslateKey: string
    classTooltip?: string
    iconSvg?: string
}

export default class SmartIconTooltip extends React.PureComponent<PropsInterface> {
    render(): ReactNode {
        const {
            descriptionTooltipTranslateKey,
            classTooltip,
            iconSvg
        } = this.props;

        return <div className="label-tooltip label-tooltip_icon">
            <div className={`field__tooltip ${classTooltip ? classTooltip : 'default-position'}`}>
                <span className="icon">
                    <SpriteIcon
                        name={iconSvg ? `#${iconSvg}` : '#svg-icon-tooltip'}
                        className="svg-default"
                    />
                </span>
                <div className="container-description">
                    <div className="description">
                        <p>{I18n.t(descriptionTooltipTranslateKey)}</p>
                    </div>
                </div>
            </div>
        </div>;
    }
}
